import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { offerCurrency, offerPrice } from '../data/landingContent';
export function StickyBuyBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const offer = document.getElementById('offer-details');
    const observer = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.05
    });
    if (offer) observer.observe(offer);
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer.disconnect();
    };
  }, []);
  const show = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-200" data-mp="212f0874rtjzf">
      {show && <motion.aside initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} aria-label="Quick access to offer" className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-between gap-3 border-t border-line bg-white px-4 py-3 shadow-[0_-6px_24px_rgba(23,50,77,0.1)] sm:hidden" data-id="element-201" data-mp="1w20z791l7aaw">
          <div className="min-w-0" data-id="element-202" data-mp="2n6xn6zz2hg14">
            <strong className="block truncate font-condensed text-lg font-bold uppercase leading-tight text-navy" data-id="element-203" data-mp="2n7z1ddbdqin2">Lessons Ready™</strong>
            <span className="block text-xs text-muted" data-id="element-204" data-mp="2x3iujryk7384">
              36 lessons + 5 bonuses · <b className="text-navy" data-id="element-205" data-mp="323oesn2i1ng6">${offerPrice} {offerCurrency}</b>
            </span>
          </div>
          <a href="#offer-details" className="shrink-0 rounded-xl bg-teal px-4 py-3 text-sm font-bold uppercase text-white no-underline transition-colors duration-150 ease-out hover:bg-teal-hover" data-id="element-206" data-mp="364qjhjf6qrpj">
            See offer
          </a>
        </motion.aside>}
    </AnimatePresence>;
}